import { Pipe, PipeTransform } from '@angular/core';
import { rect10_Dimension, rect2_Dimension, rect4_Dimension, rect6_Dimension, rect8_Dimension, round10_Dimension, round2_Dimension, round4_Dimension, round6_Dimension, round8_Dimension, seabed_Dimension, square2_Dimension, square4_Dimension, tableImageSizeFactor } from 'src/app/constants';
import { TablesPlanService } from '../../tables-plan.service';

@Pipe({
  name: 'tableCoordinates'
})
export class TableCoordinatesPipe implements PipeTransform {

  constructor(private tablesPlanService: TablesPlanService) {

  }

  transform(value: number | undefined, imgType: string | undefined, ...args: unknown[]): number {

    let offset = this.tablesPlanService.getTableCoordinatesOffset(imgType);

    if (value == null) {
      return 0;
    }
    return this.tablesPlanService.coordinateToPixels(value) - offset;
  }

}
